var map = {
	"./img-1.jpg": 385,
	"./img-10.jpg": 4,
	"./img-11.jpg": 529,
	"./img-12.jpg": 112,
	"./img-13.jpg": 337,
	"./img-14.jpg": 99,
	"./img-15.jpg": 383,
	"./img-2.jpg": 716,
	"./img-3.jpg": 613,
	"./img-4.jpg": 145,
	"./img-5.jpg": 776,
	"./img-6.jpg": 159,
	"./img-7.jpg": 338,
	"./img-8.jpg": 206,
	"./img-9.jpg": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;